import { styled, css } from "styled-components";
import { ReactComponent as IconLogo } from "../assets/icons/tbell-logo.svg";
import { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ScreenContext } from "./ScreenProvider";
import {
  Box,
  Text,
  Image,
  Stack,
  Slide,

  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { ChevronRightIcon, ChevronUpIcon } from '@chakra-ui/icons';
// import { kakaoURL } from "../assets/datas/CommonDatas";
import { HeaderMenuList } from "../assets/datas/ConstantLists";
// import arrowNext from "../assets/icons/icon-progress-arrow-right.svg";
import { footerInfo } from "../assets/datas/ConstantDatas";
import arrowDown from "../assets/icons/icon-arrow-down.svg";
import arrowUp from "../assets/icons/icon-arrow-up.svg";
import { convertFontSize } from "./Util";

const Header = styled.div`
  position: relative;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #121212;
  height: 90px;
  padding: 0 10px;
  border-bottom: 1px solid #e4e4e4;
  position: sticky;

  @media (max-width: 768px) {
    height: 50px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  width: 20%;
  padding: 0 5%;
  cursor: pointer;
  justify-content: start;

  @media (max-width: 1024px) {
    width: 25%;

    @media (max-width: 768px) {
      width: 30%;
      padding: 0 3%;
    }
  }
`;

const IconTbellLogo = styled(IconLogo)<{ ishover: string }>`
  height: 20px;
  fill: ${(props) => (props.ishover === "true" ? "#FF4343" : "white")};
  &:hover {
    fill: #ff4343;
    @media (max-width: 768px) {
      fill: white;
    }
  }

  @media (max-width: 768px) {
    fill: white;
  }
`;

const NavLink = styled(Link)<{ w?: string }>`
  text-decoration: none;
  cursor: pointer;
  width: ${(props) => props.w || "8vw"};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    color: #969696;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const NavMenu = styled.div`
  display: flex;
  width: 60%;
  height: 100%;
  justify-content: space-evenly;
  align-items: center;
`;
const NavItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 7px;
  background: none;
  border-radius: 10px;

  @media (max-width: 768px) {
    justify-content: space-between;
    margin: 5px 0;
  }
`;

const MenuTitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
const MenuWrapper = styled.div`
&::-webkit-scrollbar {
  width: 8px;
}
&::-webkit-scrollbar-thumb {
  background: #A4A8AD;
  border-radius: 5px;
}
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding: 3%;
  background: #121212;
  z-index: 10;

  @media (max-width: 768px) {
    padding: 3% 5%;
  }
`;

const MenuNavItem = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  padding: 2% 10%;
  background: none;
  // border-bottom: 2px solid #d9d9d9aa;
`;

const MenuText = styled(Text)<{
  $isselect: string;
  $ishover?: string;
}>`
  margin: 0;
  text-align: center;
  font-size: ${convertFontSize(10, 17)};
  font-weight: 700;
  color: ${(props) =>
    props.$isselect === "true" 
      ? "#27C4D5"
      : props.$ishover === "true"
      ? "#969696"
      : "white"};
  background: none;
  border-radius: 15px;
  &:hover {
    color: ${(props) =>
      props.$isselect === "true" 
        ? "#27C4D5"
        : "#969696"};
  }

  @media (max-width: 1024px) {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
  }
`;

const SubText = styled(MenuText)`
  font-size: 14px;
`;

const BtnWrapper = styled.div`
  width: 10%;
  display: flex;
  justify-content: center;
`;

const SubMenuWrapper = styled.div<{ $isopen: string }>`
  position: absolute;
  width: 100%;
  height: 0;
  max-height: 0;
  overflow: hidden;
  // transition: max-height 0.3s ease;
  transition: height 0.3s ease;
  display: flex;
  padding: 15px;
  z-index: -1;
  
  ${props => props.$isopen === "true" && css`
    max-height: calc(100vh - 90px); /* Adjust as needed */
    min-height: 385px;
    height: calc(50vh - 90px);
    background-color: #121212cc;    
    z-index: 100;
    padding: 15px;
  `}
`;

const SubWrapper = styled.div`
  cursor: pointer;
  width: 8vw;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
`;

const SubItem = styled.div<{ $ishover: string, $isActive: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 7px 0;
  border-bottom: ${(props) => 
    props.$isActive === "true" ? "1px solid #27C4D5"
    : "none"
  };

  &:hover {
    color: #27C4D5;
    p {
      color: #27C4D5;
    }
  }
  p {
    color: ${(props) => 
      props.$isActive === "true" ? "#27C4D5"
      : props.$ishover === "true" ? "#ffffff" 
      : "#969696"
    };
  }
`;

const SlideContent = styled.div`
  width: 100vw;
  height: calc(100vh - 90px);
  background-color: #121212;

  @media(max-width: 768px) {
    height: calc(100vh - 50px);
  }
`;

const SlideBody = styled.div`
  width: 100%;
  height: calc(100% - 171px);
  overflow: hidden;

  @media(max-width: 768px) {
    height: calc(100% - 81px);
  }
`;

const SlideFooter = styled.div`
  width: 100%;
  height: 171px;
  padding: 75px 50px;

  @media(max-width: 768px) {
    height: 81px;
    padding: 30px 50px;
  }
`;

const Hamburger = styled.div<{ $isopen: string }>`
  width: 25px;
  height: 100%;
  
  .line{
    width: 25px;
    height: 3px;
    background-color: #ffffff;
    display: block;
    margin: 5px auto;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }
  ${props => props.$isopen === "true" && css`
    .line:nth-child(2){
      opacity: 0;
    }
    .line:nth-child(1){
      -webkit-transform: translateY(8px) rotate(45deg);
      -ms-transform: translateY(8px) rotate(45deg);
      -o-transform: translateY(8px) rotate(45deg);
      transform: translateY(8px) rotate(45deg);
    }
    .line:nth-child(3){
      -webkit-transform: translateY(-8px) rotate(-45deg);
      -ms-transform: translateY(-8px) rotate(-45deg);
      -o-transform: translateY(-8px) rotate(-45deg);
      transform: translateY(-8px) rotate(-45deg);
    }
  `}

  &:hover{
    cursor: pointer;
  }
`;

const MainHeader = () => {
  // const stateType = process.env.REACT_APP_MODE_TYPE;
  const screen = useContext(ScreenContext).style;
  const { pathname, state } = useLocation();
  const [isHover, setIsHover] = useState<any>({
    logo: false,
    logout: false,
  });
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [currentState, setCurrentState] = useState<string>();
  const subMenuList = HeaderMenuList.map(menu => menu.children);

  const [menuStates, setMenuStates] = useState<boolean[]>(
    HeaderMenuList.map(i => false)
  );

  const handleMouseEnter = (type: string) => {
    closeSubMenu();
    if (type === "logo") setIsHover({ ...isHover, logo: true });
    else if (type === "logout") setIsHover({ ...isHover, logout: true });
  };
  const handleMouseMove = (type: string) => {
    closeSubMenu();
    if (type === "logo") setIsHover({ ...isHover, logo: true });
    else if (type === "logout") setIsHover({ ...isHover, logout: true });
  };
  const handleMouseOut = (type: string) => {
    closeSubMenu();
    if (type === "logo") setIsHover({ ...isHover, logo: false });
    else if (type === "logout") setIsHover({ ...isHover, logout: false });
  };

  const isActive = (menu: string) => {
    const path = pathname.split("/").reverse()[0];
    if (menu === path) return "true";
    return "false";
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  const closeMenu = () => {
    setIsMenuOpen((prev) => false);
  };
  const toggleSubMenu = (index: number) => {
    setIsSubMenuOpen(true);
    setCurrentIndex(index);
    // path 에 해당하는 하위 메뉴들 활성화 표시
  };
  const keepSubMenu = () => {
    setIsSubMenuOpen(true);
  };
  const closeSubMenu = () => {
    setIsSubMenuOpen(false);
    // 모든 하위 메뉴 비활성화 표시
  }

  const handleOpen = (index: number, isOpen?: boolean) => {
    // console.log(isOpen);
    setMenuStates(menuStates.map((m, i) => {
      // return i === index ? !m : false;
      return i === index && !isOpen;
    }))
  }

  useEffect(() => {
    if(!isSubMenuOpen)
      setCurrentIndex(-1);
  }, [isSubMenuOpen]);

  const checkHover = (index: number) => {
    if (currentIndex === index) return "true";
    return "false";
  };

  useEffect(() => {
    document.getElementById("main")?.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    if(state) {
      document.getElementById("main")?.scrollTo({ top: 0, behavior: "smooth" });
      checkState(state);
    }
  }, [state]);

  const checkState = (state: any) => {
    if(state.type && state.type !== "") {
      setCurrentState(state.type);
    } else {
      setCurrentState(state.data.children[0].path);
    }
  };

  useEffect(() => {
    // console.log("crntStt: ", currentState)
  }, [currentState]);
  
  return (
    <Header>
      <HeaderContainer id="main-header">
        <LogoWrapper
          onMouseEnter={() => handleMouseEnter("logo")}
          onMouseMove={() => handleMouseMove("logo")}
          onMouseOut={() => handleMouseOut("logo")}
        >
          <NavLink to={"/"} w={"fit-content"}>
            <IconTbellLogo ishover={isHover.logo.toString()} onClick={closeMenu}/>
          </NavLink>
        </LogoWrapper>
        {screen === "pc" ? (
          <>
          <NavMenu onMouseEnter={keepSubMenu} onMouseMove={keepSubMenu}>
            {HeaderMenuList?.map((menu, index) => {
              return (
                <NavLink key={index} to={menu.to} target={menu.path === "tassi" ? "_blank" : undefined} state={{ data: menu }} onMouseEnter={() => toggleSubMenu(index)}>
                  <NavItem>
                      <MenuText $isselect={isActive(menu.path)} $ishover={checkHover(index)}>
                        {menu.name}
                      </MenuText>
                  </NavItem>
                </NavLink>
              )
            })}
          </NavMenu>
          <NavMenu onMouseEnter={closeSubMenu} style={{ width: "20%" }}>
          </NavMenu>
          </>
        ) : (
          <BtnWrapper>
            <Hamburger id="hamburger-1" $isopen={isMenuOpen.toString()} onClick={toggleMenu}>
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </Hamburger>
          </BtnWrapper>
        )}
      </HeaderContainer>
      <SubMenuWrapper $isopen={(screen === "pc" && isSubMenuOpen).toString()} onMouseEnter={keepSubMenu} onMouseMove={keepSubMenu} onMouseOut={closeSubMenu}>
        <NavMenu style={{ width: "20%" }}></NavMenu>
        <NavMenu style={{ alignItems: "start" }}>
          {subMenuList.map((sub, index) => {
            return (
              <SubWrapper key={index}>
                {sub.map((item, iId) => {
                  return item.show && (
                    <SubItem key={iId} $ishover={(index === currentIndex).toString()} $isActive={(item.path === currentState).toString()}>
                      <NavLink to={item.to} target={item.path === "tassi" ? "_blank" : undefined} state={{ type: item.path, data: item }}>  {/*  state={{ type: item.path }} */}
                        <Text fontSize={convertFontSize(10, 15)}>{item.name}</Text>
                      </NavLink>
                    </SubItem>
                  )
                })}
              </SubWrapper>
            )
          })}
        </NavMenu>
        <NavMenu style={{ width: "20%" }}></NavMenu>
      </SubMenuWrapper>
      {screen !== "pc" &&
        <Slide 
          direction='right' 
          in={isMenuOpen} 
          style={{ 
            zIndex: 100, 
            height: screen === "mobile" ? "calc(100vh - 50px)" : "calc(100vh - 90px)", 
            top: screen === "mobile" ? "50px" : "90px" 
          }}
        >
          <SlideContent>
            <SlideBody>
              <MenuWrapper>
              <Accordion allowToggle>
                {HeaderMenuList?.map((menu, index) => {
                  return (
                    <AccordionItem key={index} m={screen === "mobile" ? "7% 0" : "3% 0"}>
                    {({ isExpanded }) => (
                      <>
                        <MenuTitleBox>
                          <AccordionButton _expanded={{ color: '#27C4D5' }} onClick={() => handleOpen(index, isExpanded)}>
                            <Box as="span" flex='1' textAlign='left'>
                              <MenuText $isselect={menuStates[index].toString()}>{menu.name}</MenuText>
                            </Box>
                            <AccordionIcon 
                              w={8} 
                              h={8} 
                              as={ChevronRightIcon} 
                              transform={isExpanded ? "rotate(90deg)" : "rotate(0deg)"}
                              transition={"all 0.3s ease-in-out"}
                            />
                          </AccordionButton>
                        </MenuTitleBox>
                        <AccordionPanel>
                          <Stack mt={"5%"}>
                            {menu.children?.map((c, cId) => {
                              return (
                                <NavLink key={cId} to={c.to} state={{ type: c.path, data: c }} onClick={toggleMenu}>
                                  <MenuNavItem>
                                    <SubText $isselect={(currentState === c.path).toString()}>
                                      {c.name}
                                    </SubText>
                                  </MenuNavItem>
                                </NavLink>
                              )
                            })}
                          </Stack>
                        </AccordionPanel>
                      </>
                    )}
                    </AccordionItem>
                  )
                })}
                </Accordion>
              </MenuWrapper>
            </SlideBody>
            <SlideFooter>
              <Box display={"flex"} w={"100%"} color={"#B0B0B0"} fontSize={"14px"}>
                <Text fontWeight={600} mr={"5%"} color={"#B0B0B0"}>TBELL</Text>
                <Text fontWeight={400} color={"#B0B0B0"}>{`견적상담 ${footerInfo.phone}`}</Text>
              </Box>
            </SlideFooter>
          </SlideContent>
        </Slide>
      }
    </Header>
  );
};

export default MainHeader;
